module.exports = __webpack_public_path__ + "img/blue_lock.fae72361.gif";